/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_DownloadedInputs */

const en_mobile_downloaded = /** @type {(inputs: Mobile_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloaded`)
};

const es_mobile_downloaded = /** @type {(inputs: Mobile_DownloadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargado`)
};

/**
* | output |
* | --- |
* | "Downloaded" |
*
* @param {Mobile_DownloadedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_downloaded = /** @type {((inputs?: Mobile_DownloadedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_DownloadedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_downloaded(inputs)
	return en_mobile_downloaded(inputs)
});